<template>
<transition name="fade">
  <div id="calendar" class="calendarBox" ref="calendar" :class='[{transition:transition}]' :style="{height: calendarHeight == -100 ? '6.98667rem':calendarHeight + 'rem' }"
       @touchmove="move"
       @click.prevent="toggleMove()"
       style="overflow:hidden;">
    <div style="height: 100%;white-space: nowrap" :class="{transition:transition}" :style="{transform: 'translate3d('+(calendarMove.x)+'px,'+calendarMove.y+'px,0px)'}" >
      <slot></slot>
    </div>
  </div>
</transition>
</template>
<script>
  import format from './format'
  import {formatDateTime} from "@/utils/dateTimeUtil"
  export default{
    data(){
      return{
        transition:true,//是否显示动画
        calendarHeight:6.98667, //日历的高度
        calendarMove:{
          x:0,
          y:0
        },
        move_start_x:0, //开始移动的位置x轴
        move_start_y:0, //开始移动的位置y轴
        move_mode:3,  //移动方式,1左右移动,2上下移动
        can_change_mode:false, //是否可以改变移动方式
        move_start_calendarHeight:0,  //开始移动的高度初始值
        can_move:false, //是否触发move事件
        itemWidth:0,  //窗口的宽度
        move_index:0, // 左右移动 1 向右移动-1向左移动
        line_num:0, //  选中或今天是第几行的周
        is_week:true, //是否是周历模式
        monthList:[],//周数组
        today:new Date(),
        checkDateTime:new Date(),
      }
    },
    props:['checkDate','formateTime','dateList'],
    created(){
//      初始化日历宽度和line_num
      this.itemWidth = window.innerWidth
      this.line_num = this.calc_line_num(this.checkDate)
      this.toggleMove();
    },
    watch:{
      checkDate(val){
        if(val){
          this.line_num = this.calc_line_num(val)
          // console.log(this.line_num,'行')
        }
      },
      calendarHeight(newVal){
        // console.log('---newVal---'+newVal);
        this.$emit('calendarHeight',newVal);
      },
      formateTime(value){
        this.checkDateTime = value;
      }
    },
    methods:{
      toggleMove(e){
        // console.log("点击");
        // console.log("this.calendarHeight---"+this.calendarHeight)
        if(this.calendarHeight == 1.6){
          this.calendarHeight = 6.98667;
          this.move_init(true)
          setTimeout(()=>{
          this.$parent.get3month()
          },500)

        }else{
          this.calendarHeight = 1.6;
          this.move_init(false)
        }

      },
      //      手机端端移动
      move(e){
        if(!this.can_move)return
        var touch;
        if(e.changedTouches){
          touch = e.changedTouches[0];
        }else{
          touch = e
        }
        if(this.is_week){
          // console.log(1234,this.checkDateTime)
          var year = new Date(this.checkDateTime).getFullYear()
          var month = new Date(this.checkDateTime).getMonth()
          var day = new Date(this.checkDateTime).getDate()
          // console.log(4567,year,month,day)
          this.monthList = [];
          if(this.move_start_x < touch.clientX){
            this.monthList.push(this.getWeek(year,month,day-7))
          }else{
            this.monthList.push(this.getWeek(year,month,day+7))
          }
          // console.log('monthList')
          // console.log(this.monthList[0][0][0].date)
          let propsDate = new Date(formatDateTime(new Date(this.monthList[0][0][0].date)),('YYYY-MM-DD'));
          let nowDate = new Date(formatDateTime(new Date()),('YYYY-MM-DD'));
          // console.log(11111111111111111111)
          // console.log(propsDate,nowDate)
          // console.log(propsDate >= nowDate)
          if(propsDate >= nowDate){
            if(this.move_start_x > touch.clientX){
              this.move_mode = 1;
              return
            }
          }
        }else{
          let propsDate = new Date(formatDateTime(new Date(this.checkDateTime)),('YYYY-MM'));
          let nowDate = new Date(formatDateTime(new Date()),('YYYY-MM'));
          if(propsDate >= nowDate){
            if(this.move_start_x > touch.clientX){
              this.move_mode = 1;
              return
            }
          }
        }
        this.$parent.can_click = false
        if(this.can_change_mode){
          if(Math.abs(touch.clientX - this.move_start_x) > Math.abs(touch.clientY - this.move_start_y)){
            this.move_mode = 1
          }else{
            this.move_mode = 2
          }
          this.can_change_mode = false
        }
        // console.log('方向',this.move_mode)
//        左右移动
        if(this.move_mode == 1){
          this.calendarMove.x = touch.clientX - this.move_start_x -20
        }

      },
      getWeek(year,month,day){
        //year,month,day为选中当天的年月日
        var dt = new Date(year,month,day)
        var weekArr = []
        var dt_first = new Date(year,month,day-((dt.getDay()+6) % 7))
        var week = []
        //循环选中当天所在那一周的每一天
        for(var j=0;j<7;j++){
          var newdt = new Date(dt_first.getFullYear(),dt_first.getMonth(),dt_first.getDate()+j)
          var _year = newdt.getFullYear()
          var _month = newdt.getMonth()
          var _day = newdt.getDate()
          week.push({
            mode:'week',
            day:_day,
            year:_year,
            month:_month,
            date:this.format(_year,_month,_day),
            //日历要显示的其他内容
            // thing:(day == 22 || day == 4) ? [{title:'预约',color:'red'}]:[],
            thing:this.ifOrder(_year,_month,_day),
            nongli:format.solar2lunar(_year,_month+1,_day),
            istoday:(this.today.getFullYear()==_year && this.today.getMonth()==_month && this.today.getDate() == _day)?true:false,
            ischecked:false,
            othermonth:_month!=month
          })
        }
        // console.log('---week---'+ JSON.stringify(week,null,2))
        weekArr.push(week)
        return weekArr
      },
      ifOrder(year,month,day){
        let dateTime = this.format(year,month,day);
        if(this.dateList.indexOf(dateTime) >= 0){
          return [{title:'.'}]
        }else{
          return []
        }
      },
      format(year,month,day){
        month++
        month<10&&(month='0'+month)
        day<10&&(day='0'+day)
        return year + '-' + month + '-' + day;
      },
      move_change(_index){
        this.transition = false
        this.calendarMove.x = 0
      },
      move_init(mode){
        this.is_week = !mode
        if(mode){
          var self = this
          self.calendarHeight = 6.98667
          this.calendarMove.y = 0
          //日历高度设置为最大高度
          setTimeout(function(){
            self.calendarHeight = 6.98667
          },300);
        }else{
//          恢复高度
          this.calendarHeight = 1.6
          this.calendarMove.y = -(1.6*this.line_num)
          setTimeout(()=>{
            this.$parent.get3week();
          },150)
          this.calendarMove.y = 0
        }
      },
      calc_line_num(day){
        //计算今天在第几行
        var year = day.getFullYear()
        var month = day.getMonth()
        var dt_first = new Date(year,month,1)   //每个月第一天
        var space = (dt_first.getDay() - 1 + 7) % 7   //月历前面空格
        //console.log(space + day.getDate())
        return parseInt((space + day.getDate() - 1) / 7)
      }
    }
  }
</script>
<style scoped>
  .calendarBox {
    position: relative;
    height: 6.98667rem;
    z-index: 99;

  }

  .transition{
    transition: all .2s linear;
  }
</style>
